import { MESApiService, getMomentTz, spParameter } from "@dexteel/mesf-core";
const moment = getMomentTz();
export const getProductionData = async (shiftId: number | null) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ShiftId", value: shiftId });
	parameters.push({ name: "GetDeleted", value: false });

	const response = await apiService.callV2(
		"[CAS].[GetProductionData]",
		parameters,
	);
	if (response.ok) {
		// Map production data (table 0)
		response.data.tables[0].rows = response.data.tables[0].rows.map(
			(row: any) => ({
				...row,
				TapTime: row.TapTime ? moment.utc(row.TapTime).toDate() : null,
				LadleClose: row.LadleClose ? moment.utc(row.LadleClose).toDate() : null,
			}),
		);

		// Map strand data (table 1) - convert date fields
		if (response.data.tables[1]) {
			response.data.tables[1].rows = response.data.tables[1].rows.map(
				(row: any) => ({
					...row,
					StartTime: row.StartTime ? moment.utc(row.StartTime).toDate() : null,
					EndTime: row.EndTime ? moment.utc(row.EndTime).toDate() : null,
				}),
			);
		}
	}
	return response;
};

export const getLastestHeats = async (showExternalsHeats: boolean) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "IsExternal", value: showExternalsHeats });

	return await apiService.callV2("[MS].[GetLastestHeats]", parameters);
};

export const getLastestHeatsWithLadleClose = async (
	showExternalsHeats: boolean,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "SearchTerm", value: null });
	parameters.push({ name: "IsExternal", value: showExternalsHeats });

	return await apiService.callV2(
		"[CAS].[SearchHeatsWithLadleClose]",
		parameters,
	);
};

export const searchHeatsWithProcessId = async (
	searchTerm: string,
	IsExternal: boolean,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "SearchTerm", value: searchTerm },
		{ name: "MaxResults", value: 100 },
		{ name: "IsExternal", value: IsExternal },
	];

	return await apiService.callV2("[MS].[SearchHeatsWithProcessId]", parameters);
};

export const searchHeatsWithLadleClose = async (
	searchTerm: string,
	IsExternal: boolean,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "SearchTerm", value: searchTerm },
		{ name: "MaxResults", value: 100 },
		{ name: "IsExternal", value: IsExternal },
	];

	return await apiService.callV2(
		"[CAS].[SearchHeatsWithLadleClose]",
		parameters,
	);
};
